/// <amd-module name="VSS/Features/MarkdownEditor/Commands/Shortcut" />
import { KeyCode } from "VSSUI/Util";
import { MarkdownSigns, wrapWithSign } from "../Formatting/Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "../Formatting/Contracts";
import { wrapWithLinkSign } from "../Formatting/Link";

export interface IMarkdownShortcutCommand {
    formatText?: (
        formattingArgs: IMarkdownFormattingArgs,
        event: React.KeyboardEvent<HTMLElement>
    ) => IMarkdownFormattingResult | void | Promise<IMarkdownFormattingResult | void>;
    id: string;
}

export const Bold: IMarkdownShortcutCommand = {
    formatText: (formattingArgs, event) => {
        if (event.ctrlKey && event.which === KeyCode.b) {
            return wrapWithSign(formattingArgs, MarkdownSigns.Bold);
        }
    },
    id: "bold"
};

export const Italic: IMarkdownShortcutCommand = {
    formatText: (formattingArgs, event) => {
        if (event.ctrlKey && event.which === KeyCode.i) {
            return wrapWithSign(formattingArgs, MarkdownSigns.Italic);
        }
    },
    id: "italic"
};
export const Link: IMarkdownShortcutCommand = {
    formatText: (formattingArgs, event) => {
        if (event.ctrlKey && event.which === KeyCode.k) {
            return wrapWithLinkSign(formattingArgs);
        }
    },
    id: "link"
};

export const shortcutCommands: IMarkdownShortcutCommand[] = [Bold, Italic, Link];
